module.exports = __webpack_public_path__ + "static/media/Logomark White.9434e654.png";